module.exports = __webpack_public_path__ + "static/community-left-2b03be637b01b5a488417e3a87d5528b.webp";